import { apiHelper } from './api';

export const moduleService = {
  // Get all modules
  getModules: async () => {
    const response = await apiHelper.get('/modules');
    return response.data;
  },

  // Get single module by ID
  getModule: async (moduleId) => {
    const response = await apiHelper.get(`/modules/${moduleId}`);
    return response.data;
  },

  // Create new module
  createModule: async (moduleData) => {
    const response = await apiHelper.post('/modules', moduleData);
    return response.data;
  },

  // Update module
  updateModule: async (moduleId, moduleData) => {
    const response = await apiHelper.put(`/modules/${moduleId}`, moduleData);
    return response.data;
  },

  // Delete module
  deleteModule: async (moduleId) => {
    const response = await apiHelper.delete(`/modules/${moduleId}`);
    return response.data;
  }
};